"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var tooltip_1 = __importDefault(require("relements/build/esm/overlays/tooltip"));
var InfoIconV4_1 = __importDefault(require("relements/build/esm/ui/icons/InfoIconV4"));
// Styled-Components
var StyledComponets_1 = require("./StyledComponets");
var TrainContainerUrl = function (_a) {
    var onChangeTrainingUrl = _a.onChangeTrainingUrl, trainingUrl = _a.trainingUrl, disabled = _a.disabled;
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(box_1["default"], { flexDirection: "column", padding: "24px", borderStyle: "solid", borderColor: "grey.haptik", borderWidth: "1px", width: "746px", borderRadius: "8px", backgroundColor: "grey.pastel" },
            react_1["default"].createElement(box_1["default"], { padding: "0", alignItems: "center" },
                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Training URLs"),
                react_1["default"].createElement(tooltip_1["default"], { themed: true, tooltip: "Add the URLs to upload data set for the bot", position: "TOP" },
                    react_1["default"].createElement(InfoIconV4_1["default"], { size: "small", iconColor: "grey.dark", marginLeft: "6px" }))),
            react_1["default"].createElement(StyledComponets_1.StyledInfoContainer, null,
                react_1["default"].createElement(InfoIconV4_1["default"], { size: "small", iconColor: "grey.dark", marginRight: "6px" }),
                react_1["default"].createElement(text_1["default"], null,
                    "To generate Sitemap of a given website, please use",
                    ' ',
                    react_1["default"].createElement(StyledComponets_1.StyledLink, { href: "https://www.xml-sitemaps.com/", target: "_blank", rel: "noreferrer noopener" }, "XML Sitemap Generator"),
                    ".")),
            react_1["default"].createElement(StyledComponets_1.StyledText, { variant: "body.lg", color: "black.haptik" }, "Google Sheet Link"),
            react_1["default"].createElement(StyledComponets_1.StyledTextInput, { value: trainingUrl, onChange: onChangeTrainingUrl, themed: true, placeholder: "Enter Google Sheet Link here", disabled: disabled }))));
};
exports["default"] = TrainContainerUrl;
